import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import ScrollToTop from '../components/landing/ScrollToTop'
import Navbar from '../components/landing/Navbar'
import { Footer } from '../components/landing/Footer'
import { Box } from '@mui/system'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger);

export default function PublicLayout() {

    // useEffect(() => {
    //     const lenis = new Lenis({
    //         duration: 1.2,        // scroll duration — tune this
    //         easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // expo ease
    //         smoothWheel: true,    // smooth mouse wheel
    //         smoothTouch: false,   // keep native on touch/mobile
    //     });

    //     // ✅ Critical — sync Lenis with GSAP ticker
    //     // Without this ScrollTrigger animations will be janky
    //     lenis.on('scroll', ScrollTrigger.update);

    //     gsap.ticker.add((time) => {
    //         lenis.raf(time * 1000);
    //     });

    //     gsap.ticker.lagSmoothing(0); // ✅ prevents lag spikes

    //     return () => {
    //         lenis.destroy();
    //         gsap.ticker.remove((time) => lenis.raf(time * 1000));
    //     };
    // }, []);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.5,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
        });

        lenis.on('scroll', ScrollTrigger.update);

        // ✅ store the ticker function so cleanup can remove the SAME reference
        const tickerFn = (time) => lenis.raf(time * 1000);

        gsap.ticker.add(tickerFn);
        gsap.ticker.lagSmoothing(0);

        return () => {
            lenis.destroy();
            gsap.ticker.remove(tickerFn); // ✅ now removes the correct reference
        };
    }, []);

    return (
        <>
            {/* ✅ Navbar outside scroll content — fixed elements stay stable */}
            <div style={{
                paddingTop: '15px',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
            }}>
                <div className='container'>
                    <Navbar />
                </div>
            </div>

            {/* ✅ No more smooth-wrapper/smooth-content divs needed */}
            <div className='main-wrapper'>
                <ScrollToTop />
                <Outlet />

                <Box sx={{ py: { xs: 1.5, md: 3 } }}>
                    <div className="container">
                        <Footer />
                    </div>
                </Box>
            </div>
        </>
    )
}

// import React, { useEffect, useRef } from 'react'
// import { Outlet, useLocation } from 'react-router-dom'
// import ScrollToTop from '../components/landing/ScrollToTop'
// import Navbar from '../components/landing/Navbar'
// import { Footer } from '../components/landing/Footer'
// import { Box } from '@mui/system'
// import gsap from 'gsap'
// import { useGSAP } from '@gsap/react'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { ScrollSmoother } from 'gsap/ScrollSmoother';

// export default function PublicLayout() {
//     const { pathname } = useLocation();
//     const smoother = useRef();

//     useGSAP(() => {
//         gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

//         smoother.current = ScrollSmoother.create({
//             wrapper: '#smooth-wrapper',
//             content: '#smooth-content',
//             smooth: 1,
//             effects: true,
//             smoothTouch: 0,
//             normalizeScroll: true,
//         });

//         return () => {
//             smoother.current?.kill(); // cleanup on unmount
//         };
//     });

//     // useEffect(() => {
//     //     gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

//     //     smoother.current = ScrollSmoother.create({
//     //         wrapper: '#smooth-wrapper',
//     //         content: '#smooth-content',
//     //         smooth: 1,
//     //         effects: true,
//     //         smoothTouch: 0,
//     //         normalizeScroll: true,
//     //     });

//     //     return () => {
//     //         smoother.current?.kill(); // cleanup on unmount
//     //     };
//     // }, []);

//     return (
//         <div id="smooth-wrapper" className='main-wrapper'>

//             <div id="smooth-content">

//                 <div style={{
//                     paddingTop: '15px',
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     zIndex: 1000,
//                 }}>
//                     <div className='container'>
//                         <Navbar />
//                     </div>
//                 </div>

//                 <ScrollToTop />
//                 <Outlet />

//                 <Box sx={{ py: { xs: 1.5, md: 3 } }}>

//                     <div className="container">
//                         <Footer />

//                     </div>

//                 </Box>

//             </div>
//         </div >
//     )
// }
